module.exports = __webpack_public_path__ + "static/media/Girl-in-blazer-and-glasses-355934-min.c14b5733.jpg";